export default function replaceAll(text, searchText, replaceText) {
	try {
		return text.replace(new RegExp(searchText, 'g'), replaceText)
	} catch (e) {
		return text
	}
}
